import { IRoomSummary, ITrendKeyPath } from "@backend/src/shared/schemas/schemas";
import { PartialMcBimSpace } from "../utils";
import type {
  ERoomColoringCategoryId,
  ERoomColoringSubcategoryId,
  IRoomColoringExplanation,
} from "./roomColoringConstants";

export interface IColorSpec {
  id: string;
  fillColor: string;
  borderColor?: string;
  explanation: string;
  range?: {
    minExclusive?: number;
    minInclusive?: number;
    maxInclusive?: number;
  };
}

export interface IPolygonColors {
  fill?: string;
  stroke?: string;
}

export interface IGetColorArgs {
  room?: IRoomSummary;
  space?: PartialMcBimSpace;
  colorSpecs: IColorSpec[];
}

export enum ROOM_COLORING_IDS {
  SPACE_BELONG_TO_STANDARD_ROOM = "SPACE_BELONG_TO_STANDARD_ROOM",
  SUPPLY_AIR_FLOW = "SUPPLY_AIR_FLOW",
  RETURN_AIR_FLOW = "RETURN_AIR_FLOW",
  MMI = "MMI",
  CEILING_MMI = "CEILING_MMI",
  DR_STATUS = "DR_STATUS",
  DESIGN_DEVIATION_STATUS = "DESIGN_DEVIATION_STATUS",
  ROOM_NUMBERING = "ROOM_NUMBERING",
  CEILING_COMMENTS = "CEILING_COMMENTS",
}

export interface IRoomColoring {
  id: ROOM_COLORING_IDS | string;
  title: string;
  categoryId: ERoomColoringCategoryId;
  subcategoryId?: ERoomColoringSubcategoryId;
  explanation: IRoomColoringExplanation;
  order?: number;
  tags?: string[];
  getPolygonColors: (args: IGetColorArgs) => IPolygonColors;
  colorSpecs: IColorSpec[];
  trendKeyPath?: ITrendKeyPath;
}
